
import { Store } from "@ngxs/store";
import { Diary, Encounter, IDiaryHandler, IDiaryManagerFactory, IDiaryManagerItem, WindowService} from "@harlowe/core";
import { EncounterService } from "../../../services/encounter.service";
import { TealHealthEncounterHeader } from "../../../models/encounter";
import { Observable, from, map, of, switchMap } from "rxjs";
import { EncounterDiaryHandler } from "./encounter-diary-handler";
import { inject, InjectionToken } from "@angular/core";

export const HEMI_BASE_URL = new InjectionToken<string>('Hemi_Base_Url');

export class EncounterDiaryManagerItem implements IDiaryManagerItem
{    
    constructor
    (
        private _hemiBaseUrl: string,
        private _diary: Diary,
        private _encounter: TealHealthEncounterHeader | undefined,
        private _member: string | undefined,
        private _store: Store,
        private _handler: EncounterDiaryHandler | undefined,
        private _windowService: WindowService,
    )
    {

    }

    get dueDate(): Date {
        return this._diary.dueDate ?? new Date();
    }

    get id(): number | string {
        return this._diary.id;
    }

    getRelatedToText(): string | undefined
    {
        return this._member;
    }

    goToRelatedItem(): void 
    {
        this._windowService.nativeWindow.open(this.getEncounterUrl(), '_top', 'noopener,noreferrer');
    }

    getEncounterUrl(): string {
        return this._hemiBaseUrl + "/encounter/" + this._encounter?.id;
    }

    getHandler(): IDiaryHandler | undefined
    {
        return this._handler;
    }

    getDiary(): Diary 
    {
        return this._diary;
    }
}
export class EncounterDiaryManagerItemFactory implements IDiaryManagerFactory
{

    private _encounterService: EncounterService = inject(EncounterService)
    private _windowService: WindowService = inject(WindowService)
    private _store: Store = inject (Store)
    private _hemiBaseUrl: string = inject(HEMI_BASE_URL); 

    constructor()
    {

    }

    createDiaryManagerItems(diaries$: Observable<Diary[]>): Observable<IDiaryManagerItem[]> {
        //Get all the encounters associated with these diaries first
        return diaries$.pipe
            (
                switchMap(diaries => {
                    const ids = diaries.filter(d => d != undefined).map(d => d.encounterId as number);
                    if (ids.length === 0) return of([] as IDiaryManagerItem[]);
                    return from(this._encounterService.getEncounters(ids)).pipe(
                        map(encounters => diaries.map(d => {
                            const enc = encounters.find(e => d.encounterId === e.id);
                            const handler = enc ? new EncounterDiaryHandler(enc, this._encounterService, this._store) : undefined;
                            return new EncounterDiaryManagerItem(this._hemiBaseUrl, d, enc, enc?.member, this._store, handler, this._windowService);
                        }))
                    );
                })
            )
    }


    createDiaryManagerItem(diary$: Observable<Diary>): Observable<IDiaryManagerItem>
    {
        return this.createDiaryManagerItems(diary$.pipe(map(d => [d]))).pipe(map(d => d[0]))
    }
}

